import script from "./DeletePrompt.vue?vue&type=script&setup=true&lang=js"
export * from "./DeletePrompt.vue?vue&type=script&setup=true&lang=js"

import "./DeletePrompt.vue?vue&type=style&index=0&id=43d53d8a&lang=scss&scoped=true"

import exportComponent from "/builds/strooka-jagaad/strooka-fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43d53d8a"]])

export default __exports__